/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_tm_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Free oligo Tm calculator. Compute the melting temperature of a DNA primer with the nearest-neighbor (SantaLucia 1998) method plus salt correction, and compare the Wallace and GC% estimates.`)
};

const es_tm_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Calculadora gratuita de Tm de oligos. Calcula la temperatura de fusión de un cebador de ADN con el método de vecino más cercano (SantaLucia 1998) más corrección de sal, y compara con las estimaciones de Wallace y %GC.`)
};

const de_tm_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kostenloser Oligo-Tm-Rechner. Berechnen Sie die Schmelztemperatur eines DNA-Primers mit der Nearest-Neighbor-Methode (SantaLucia 1998) plus Salzkorrektur und vergleichen Sie die Wallace- und GC%-Schätzungen.`)
};

const nl_tm_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gratis oligo-Tm-calculator. Bereken de smelttemperatuur van een DNA-primer met de nearest-neighbor-methode (SantaLucia 1998) plus zoutcorrectie, en vergelijk met de Wallace- en GC%-schattingen.`)
};

const fr_tm_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Calculateur gratuit de Tm d'oligo. Calculez la température de fusion d'une amorce d'ADN avec la méthode des plus proches voisins (SantaLucia 1998) plus correction de sel, et comparez avec les estimations de Wallace et du %GC.`)
};

const it_tm_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Calcolatore gratuito di Tm per oligo. Calcola la temperatura di fusione di un primer di DNA con il metodo dei vicini più prossimi (SantaLucia 1998) più la correzione salina, e confronta le stime di Wallace e GC%.`)
};

const pt_br2_tm_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Calculadora gratuita de Tm de oligo. Calcule a temperatura de fusão de um primer de DNA com o método do vizinho mais próximo (SantaLucia 1998) mais correção de sal, e compare com as estimativas de Wallace e GC%.`)
};

const pt_tm_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Calculadora gratuita de Tm de oligonucleótidos. Calcule a temperatura de fusão de um primer de ADN com o método do vizinho mais próximo (SantaLucia 1998) mais a correção salina, e compare com as estimativas de Wallace e de GC%.`)
};

const ja_tm_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`無料のオリゴTm計算ツール。最近接塩基対法 (SantaLucia 1998) と塩濃度補正を使ってDNAプライマーの融解温度を計算し、WallaceおよびGC%による推定値と比較します。`)
};

const zh_tm_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`免费寡核苷酸 Tm 计算器。使用最近邻法（SantaLucia 1998）并结合盐浓度校正计算 DNA 引物的解链温度，同时提供 Wallace 规则和 GC% 估算值以供比较。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const tm_meta_description = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.tm_meta_description(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("tm_meta_description", locale)
	if (locale === "en") return en_tm_meta_description(inputs)
	if (locale === "es") return es_tm_meta_description(inputs)
	if (locale === "de") return de_tm_meta_description(inputs)
	if (locale === "nl") return nl_tm_meta_description(inputs)
	if (locale === "fr") return fr_tm_meta_description(inputs)
	if (locale === "it") return it_tm_meta_description(inputs)
	if (locale === "pt-BR") return pt_br2_tm_meta_description(inputs)
	if (locale === "pt") return pt_tm_meta_description(inputs)
	if (locale === "ja") return ja_tm_meta_description(inputs)
	return zh_tm_meta_description(inputs)
};